import { simpleFormValidation, addEventDelegation, htmlEscape } from "../../_global/js/global.js";

(function () {
    const contactForm = document.querySelector(".emergency-form");
    if (contactForm) {
        const form = contactForm.closest("form");
        const submitButton = form.querySelector('.footer-btn-container button[type="submit"]');

        const phoneInput = document.querySelector("[data-phone-array]");
        const phoneList = document.querySelector(".contact-phone-number-rows-container");

        const getSelectedPhoneIndex = (button) => button.closest("[data-phone-index]").getAttribute("data-phone-index");

        const getPhoneObjectFromArray = (button) => {
            let phoneData = phoneInput.getAttribute("value");
            const phoneArray = parseArray(phoneData);
            const phoneIndex = getSelectedPhoneIndex(button);
            return phoneArray[phoneIndex];
        };

        // Update dialog with phone data
        const setModalPhoneData = (button) => {
            const dialog = button.getAttribute("data-dialog");
            const modal = document.querySelector(`dialog[data-dialog="${dialog}"]`);
            const phoneIndex = getSelectedPhoneIndex(button);
            modal.setAttribute("data-phone-index", phoneIndex);
            const newPhone = button.hasAttribute("data-new-phone");
            modal.setAttribute("data-new-phone", newPhone);
        };

        const updatePhoneInput = (phoneArray) => {
            const phoneData = JSON.stringify(phoneArray);
            phoneInput.setAttribute("value", phoneData);
        };
        const updateModalPhoneTable = (button) => {
            // Generate the HTML
            let phoneTableHtml = "";
            const phoneRows = document.querySelectorAll(".contact-phone-number-row:not(.hide)");
            phoneRows.forEach((phoneRow) => {
                const phoneRowNumberType = htmlEscape(phoneRow.querySelector(".phone-number-desc").innerText);
                const phoneRowNumber = htmlEscape(phoneRow.querySelector(".phone-number").innerText);
                phoneTableHtml += `
                    <tr>
                        <td>${phoneRowNumberType}</td>
                        <td>${phoneRowNumber}</td>
                    </tr>\n`;
            });
            if (phoneTableHtml) {
                phoneTableHtml = `
                    <div class="responsive-table">
                        <table>
                            <tr>
                                <th>Number Type</th>
                                <th>Phone number</th>
                            </tr>
                            ${phoneTableHtml}
                        </table>
                    </div>\n`;
            } else {
                phoneTableHtml = "<p>No numbers recorded for this contact</p>";
            }

            // Update the DOM
            const dialog = button.getAttribute("data-dialog");
            const modal = document.querySelector(`dialog[data-dialog="${dialog}"]`);
            const modalTable = modal.querySelector(`[data-${dialog}-table]`);
            modalTable.innerHTML = phoneTableHtml;
        };

        const parseArray = (string) => {
            try {
                return JSON.parse(string);
            } catch {}
            return [];
        };

        // Add button
        const phoneAddButton = document.querySelectorAll('button[data-dialog="phone-add"]');
        phoneAddButton.forEach((button) => {
            button.addEventListener("click", () => {
                updateModalPhoneTable(button);
                setModalAddData();
                limitSelectablePhoneTypes("phone-add");
                clearPhoneValidationErrors("data-phone-add-form");
            });
        });
        const setModalAddData = () => {
            const numberTypePlaceholder = document.querySelector("[data-phone-add-type]");
            const numberPlaceholder = document.querySelector("[data-phone-add-number]");
            numberTypePlaceholder.value = "";
            numberPlaceholder.value = "";
        };
        const limitSelectablePhoneTypes = (dialog) => {
            // Only 1 Mobile (M - added in DBSS3-593) 1 Mobile Public (MPL) and only 1 Work (WI) number is allowed
            const typeLimitations = [
                { type: "M", limit: 1 },
                { type: "MPL", limit: 1 },
                { type: "W1", limit: 1 },
            ];
            const selectedType = document.querySelector(`dialog[data-dialog="${dialog}"] [name="phone-number-type"]`).value;
            const disabledOptions = document.querySelectorAll(`dialog[data-dialog="${dialog}"] [name="phone-number-type"] option:disabled`);
            disabledOptions.forEach((option) => (option.disabled = false));
            const phoneData = phoneInput.getAttribute("value");
            let phoneArray = parseArray(phoneData);
            phoneArray = phoneArray.filter((number) => number.action !== "D");
            typeLimitations.forEach((typeLimitation) => {
                const typeNumbers = phoneArray.filter((number) => number.phonetype === typeLimitation.type);
                if (typeNumbers.length >= typeLimitation.limit && typeLimitation.type !== selectedType) {
                    const disableOption = document.querySelector(`dialog[data-dialog="${dialog}"] [name="phone-number-type"] option[value="${typeLimitation.type}"]`);
                    disableOption.disabled = true;
                }
            });
        };

        // Add phone number
        const phoneAddActionButtons = document.querySelectorAll('button[data-dialog-action="phone-add"]');
        const phoneAddForm = document.querySelector("form[data-phone-add-form]");
        phoneAddActionButtons.forEach((button) => {
            button.addEventListener("click", () => {
                if (simpleFormValidation(phoneAddForm, true)) {
                    pushPhoneArray();
                    addPhoneRow();
                    updatePhoneIndexes();
                    phoneAddForm.closest("dialog").close();
                }
            });
        });
        const pushPhoneArray = () => {
            const phoneData = phoneInput.getAttribute("value");
            let phoneArray = parseArray(phoneData);
            let newPhoneObject = {};
            newPhoneObject.phonetype = document.querySelector("[data-phone-add-type]").value;
            newPhoneObject.phonenumber = document.querySelector("[data-phone-add-number]").value;
            newPhoneObject.action = "A";
            phoneArray.push(newPhoneObject);
            updatePhoneInput(phoneArray);
        };
        const addPhoneRow = () => {
            const numberTypeSelect = document.querySelector("[data-phone-add-type]");
            const numberTypeSelectSelected = numberTypeSelect.selectedIndex;
            const phoneType = numberTypeSelect[numberTypeSelectSelected].text;
            const phoneNumber = document.querySelector("[data-phone-add-number]").value;
            const phoneHtml = `
                <div class="contact-phone-number-row" data-phone-index>
                    <div class="phone-number-desc">${phoneType}</div>
                    <div class="phone-number">${phoneNumber}</div>
                    <div class="edit-btn"><button type="button" data-dialog="phone-edit" title="Edit phone number" data-new-phone>Edit Number</button></div>
                    <div class="delete-btn">
                        <button type="button" data-dialog="phone-delete" class="no-style" title="Delete phone number" data-new-phone>
                            <svg width="25" height="29" viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.773 25.715C1.773 26.4205 2.05325 27.0971 2.5521 27.5959C3.05094 28.0948 3.72752 28.375 4.433 28.375H20.394C21.0995 28.375 21.7761 28.0948 22.2749 27.5959C22.7738 27.0971 23.054 26.4205 23.054 25.715V7.09401H1.773V25.715ZM16.848 11.527C16.8557 11.297 16.9525 11.0791 17.1179 10.9191C17.2833 10.7592 17.5044 10.6698 17.7345 10.6698C17.9646 10.6698 18.1857 10.7592 18.3511 10.9191C18.5165 11.0791 18.6133 11.297 18.621 11.527V23.941C18.625 24.0599 18.605 24.1784 18.5623 24.2895C18.5195 24.4005 18.4549 24.5018 18.3721 24.5874C18.2894 24.6729 18.1904 24.7409 18.0808 24.7874C17.9713 24.8338 17.8535 24.8578 17.7345 24.8578C17.6155 24.8578 17.4977 24.8338 17.3882 24.7874C17.2786 24.7409 17.1796 24.6729 17.0969 24.5874C17.0141 24.5018 16.9495 24.4005 16.9067 24.2895C16.864 24.1784 16.844 24.0599 16.848 23.941V11.527ZM11.528 11.527C11.5357 11.297 11.6325 11.0791 11.7979 10.9191C11.9633 10.7592 12.1844 10.6698 12.4145 10.6698C12.6446 10.6698 12.8657 10.7592 13.0311 10.9191C13.1965 11.0791 13.2933 11.297 13.301 11.527V23.941C13.305 24.0599 13.285 24.1784 13.2423 24.2895C13.1995 24.4005 13.1349 24.5018 13.0521 24.5874C12.9694 24.6729 12.8704 24.7409 12.7608 24.7874C12.6513 24.8338 12.5335 24.8578 12.4145 24.8578C12.2955 24.8578 12.1777 24.8338 12.0682 24.7874C11.9586 24.7409 11.8596 24.6729 11.7769 24.5874C11.6941 24.5018 11.6295 24.4005 11.5867 24.2895C11.544 24.1784 11.524 24.0599 11.528 23.941V11.527ZM6.208 11.527C6.20401 11.4081 6.22398 11.2896 6.26673 11.1785C6.30948 11.0675 6.37414 10.9662 6.45685 10.8806C6.53957 10.7951 6.63865 10.7271 6.74819 10.6806C6.85774 10.6342 6.97551 10.6102 7.0945 10.6102C7.21349 10.6102 7.33126 10.6342 7.44081 10.6806C7.55035 10.7271 7.64943 10.7951 7.73214 10.8806C7.81486 10.9662 7.87952 11.0675 7.92227 11.1785C7.96502 11.2896 7.98499 11.4081 7.981 11.527V23.941C7.98499 24.0599 7.96502 24.1784 7.92227 24.2895C7.87952 24.4005 7.81486 24.5018 7.73214 24.5874C7.64943 24.6729 7.55035 24.7409 7.44081 24.7874C7.33126 24.8338 7.21349 24.8578 7.0945 24.8578C6.97551 24.8578 6.85774 24.8338 6.74819 24.7874C6.63865 24.7409 6.53957 24.6729 6.45685 24.5874C6.37414 24.5018 6.30948 24.4005 6.26673 24.2895C6.22398 24.1784 6.20401 24.0599 6.208 23.941V11.527ZM23.941 1.77301H17.291L16.77 0.737009C16.6596 0.515386 16.4895 0.328979 16.2789 0.198771C16.0684 0.0685639 15.8256 -0.00027334 15.578 8.89114e-06H9.244C8.99706 -0.000899043 8.75484 0.0677466 8.5451 0.198087C8.33535 0.328428 8.16654 0.515195 8.058 0.737009L7.537 1.77301H0.887C0.651753 1.77301 0.426141 1.86646 0.259796 2.03281C0.0934515 2.19915 0 2.42476 0 2.66001L0 4.43401C0 4.66926 0.0934515 4.89487 0.259796 5.06121C0.426141 5.22756 0.651753 5.32101 0.887 5.32101H23.941C24.1762 5.32101 24.4019 5.22756 24.5682 5.06121C24.7345 4.89487 24.828 4.66926 24.828 4.43401V2.66001C24.828 2.42476 24.7345 2.19915 24.5682 2.03281C24.4019 1.86646 24.1762 1.77301 23.941 1.77301Z" fill="#532A45"></path></svg>
                        </button>
                    </div>
                </div>`;
            phoneList.insertAdjacentHTML("beforeend", phoneHtml);
        };

        const phoneAddOrEditActions = (target) => {
            const dialog = target.getAttribute("data-dialog");
            if (dialog === "phone-edit") {
                setModalPhoneData(target);
                updateModalPhoneTable(target);
                setModalEditData(target);
                limitSelectablePhoneTypes("phone-edit");
                clearPhoneValidationErrors("data-phone-edit-form");
            } else if (dialog === "phone-delete") {
                setModalPhoneData(target);
                setModalDeleteData(target);
            }
        };
        addEventDelegation(".contact-phone-number-rows-container", "[data-dialog]", "click", phoneAddOrEditActions);

        const setModalEditData = (button) => {
            const phoneObject = getPhoneObjectFromArray(button);
            const numberTypeData = phoneObject.phonetype;
            const numberData = phoneObject.phonenumber;
            const numberTypePlaceholder = document.querySelector("[data-phone-edit-type]");
            const numberPlaceholder = document.querySelector("[data-phone-edit-number]");
            numberTypePlaceholder.value = numberTypeData;
            numberPlaceholder.value = numberData;
        };

        // Edit phone number
        const phoneEditActionButtons = document.querySelectorAll('button[data-dialog-action="phone-edit"]');
        const phoneEditForm = document.querySelector("form[data-phone-edit-form]");
        phoneEditActionButtons.forEach((button) => {
            button.addEventListener("click", () => {
                if (simpleFormValidation(phoneEditForm, true)) {
                    const newPhone = button.closest("dialog").getAttribute("data-new-phone");
                    editPhoneArray(button, newPhone);
                    updatePhoneRow(button);
                    phoneEditForm.closest("dialog").close();
                }
            });
        });
        const editPhoneArray = (button, newPhone) => {
            const phoneData = phoneInput.getAttribute("value");
            let phoneArray = parseArray(phoneData);
            const phoneIndex = getSelectedPhoneIndex(button);
            phoneArray[phoneIndex].phonetype = document.querySelector("[data-phone-edit-type]").value;
            phoneArray[phoneIndex].phonenumber = document.querySelector("[data-phone-edit-number]").value;
            if (newPhone === "false") {
                phoneArray[phoneIndex].action = "U";
            }
            updatePhoneInput(phoneArray);
        };
        const updatePhoneRow = (button) => {
            const phoneIndex = getSelectedPhoneIndex(button);
            const phoneRow = document.querySelector(`.contact-phone-number-row[data-phone-index="${phoneIndex}"]`);
            const phoneRowNumberType = phoneRow.querySelector(".phone-number-desc");
            const phoneRowNumber = phoneRow.querySelector(".phone-number");
            const numberTypeSelect = document.querySelector("[data-phone-edit-type]");
            const numberTypeSelectSelected = numberTypeSelect.selectedIndex;
            const numberTypeData = numberTypeSelect[numberTypeSelectSelected].text;
            const numberData = document.querySelector("[data-phone-edit-number]").value;
            phoneRowNumberType.innerText = numberTypeData;
            phoneRowNumber.innerText = numberData;
        };

        const setModalDeleteData = (button) => {
            // The data could be pulled from the phone array, but the number type has already been converted to its descriptive form here
            const numberTypeData = button.closest("[data-phone-index]").querySelector(".phone-number-desc").innerText;
            const numberData = button.closest("[data-phone-index]").querySelector(".phone-number").innerText;
            const numberTypePlaceholder = document.querySelector("[data-delete-number-type]");
            const numberPlaceholder = document.querySelector("[data-delete-number]");
            numberTypePlaceholder.innerText = numberTypeData;
            numberPlaceholder.innerText = numberData;
        };

        // Delete phone number
        const phoneDeleteActionButtons = document.querySelectorAll('button[data-dialog-action="phone-delete"]');
        phoneDeleteActionButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const newPhone = button.closest("dialog").getAttribute("data-new-phone");
                actionDeleteInPhoneArray(button, newPhone);
                removePhoneRow(button, newPhone);
                updatePhoneIndexes();
            });
        });
        const actionDeleteInPhoneArray = (button, newPhone) => {
            const phoneData = phoneInput.getAttribute("value");
            let phoneArray = parseArray(phoneData);
            const phoneIndex = getSelectedPhoneIndex(button);
            if (newPhone === "true") {
                phoneArray.splice(phoneIndex, 1);
            } else {
                phoneArray[phoneIndex].action = "D";
            }
            updatePhoneInput(phoneArray);
        };
        const removePhoneRow = (button, newPhone) => {
            const phoneIndex = getSelectedPhoneIndex(button);
            const phoneRow = document.querySelector(`.contact-phone-number-row[data-phone-index="${phoneIndex}"]`);
            if (newPhone === "true") {
                phoneRow.remove();
            } else {
                phoneRow.classList.add("hide");
            }
        };
        const updatePhoneIndexes = () => {
            const phoneRows = document.querySelectorAll(".contact-phone-number-row[data-phone-index]");
            phoneRows.forEach((row, i) => {
                row.setAttribute("data-phone-index", i);
            });
        };

        const clearPhoneValidationErrors = (formName) => {
            const form = document.querySelector(`form[${formName}]`);
            // Copied from the simpleFormValidation plugin function
            // Remove all existing errors
            // Loop through each question group with this error class
            form.querySelectorAll(".sq-form-question-error").forEach((questionGroup) => {
                // Remove question group error class
                questionGroup.classList.remove("sq-form-question-error");

                // Remove aria-describedby attribute applied on fields within the group
                // Loop through checkboxes / radios
                questionGroup.querySelectorAll("[aria-describedby]").forEach((elField) => {
                    elField.removeAttribute("aria-describedby");
                });

                // Remove error message element
                let elErrorMessage = questionGroup.querySelector(".sq-form-error");

                if (elErrorMessage) {
                    elErrorMessage.remove();
                }
            });
        };

        // Add emergency address button
        const toggleEmergencyAddressButton = document.querySelector('button[data-action="toggle-emergency-address"]');
        if (toggleEmergencyAddressButton) {
            toggleEmergencyAddressButton.addEventListener("click", () => {
                const emergencyAddressSection = document.querySelector('div[data-section="emergency-address"]');
                if (emergencyAddressSection) {
                    const isSectionHidden = emergencyAddressSection.classList.contains("hide");
                    if (isSectionHidden) {
                        toggleEmergencyAddressButton.classList.add("toggle-emergency-address--remove");
                        emergencyAddressSection.classList.remove("hide");
                    } else {
                        toggleEmergencyAddressButton.classList.remove("toggle-emergency-address--remove");
                        emergencyAddressSection.classList.add("hide");
                    }
                }
                populateHiddenRequiredEmergencyFields();
            });
        }

        // Delete emergency address
        const deleteEmergencyAddressButton = document.querySelector('button[data-dialog-action="emergency-address-delete"]');
        if (deleteEmergencyAddressButton) {
            deleteEmergencyAddressButton.addEventListener("click", () => {
                const deleteEmergencyAddressFlagField = document.querySelector("input[data-eitdelete]");
                if (deleteEmergencyAddressFlagField) {
                    deleteEmergencyAddressFlagField.value = "Y";
                }
                if (toggleEmergencyAddressButton) {
                    toggleEmergencyAddressButton.classList.add("hide");
                }
                const emergencyAddressSection = document.querySelector('div[data-section="emergency-address"]');
                emergencyAddressSection.classList.add("hide");
                populateHiddenRequiredEmergencyFields();
                submitButton.click();
            });
        }

        // Toggle relationship date start (relndatestart) required error
        const emergencyflagCheckbox = document.querySelector('input[data-input="emergencyflag"]');
        if (emergencyflagCheckbox) {
            emergencyflagCheckbox.addEventListener("click", () => {
                const relndatestartRequiredError = document.querySelector('div[data-error="relndatestart-required"]');
                if (relndatestartRequiredError) {
                    const isErrorHidden = relndatestartRequiredError.classList.contains("hide");
                    if (isErrorHidden) {
                        relndatestartRequiredError.classList.remove("hide");
                    } else {
                        relndatestartRequiredError.classList.add("hide");
                    }
                }
            });
        }

        // Empty address fields when replace-address-button clicked
        const replaceAddressButton = document.querySelector(".replace-address-button");
        if (replaceAddressButton) {
            const urlParams = new URLSearchParams(window.location.search);

            // Hide button if method is POST in url
            if (urlParams.has("method") && urlParams.get("method") === "POST") {
                replaceAddressButton.style.display = "none";
            }

            const confirmReplaceAddressButton = document.querySelector(".conrirm-replace-address-button");

            confirmReplaceAddressButton.addEventListener("click", () => {
                const addressFields = document.querySelector('[data-section="main-address"]').querySelectorAll("input, select");
                addressFields.forEach((field) => {
                    field.value = "";
                });
            });
        }

        // Change address fields depending on data-address-style selection
        const addressStyleField = document.querySelector("[data-address-style]");
        if (addressStyleField) {
            addressStyleField.addEventListener("change", () => {
                const addressTypeAreas = document.querySelectorAll("[data-address-type]");
                addressTypeAreas.forEach((addressTypeArea) => {
                    addressTypeArea.classList.add("hide");
                });
                const selectedAddressType = addressStyleField.value;
                let selectedAddressTypeArea = document.querySelector(`[data-address-type="${selectedAddressType}"]`);
                if (!selectedAddressTypeArea) {
                    selectedAddressTypeArea = document.querySelector(`[data-address-type="OTHER"]`);
                }
                if (addressStyleField.value !== "") {
                    selectedAddressTypeArea.classList.remove("hide");
                }
                populateHiddenRequiredAddressFields();
            });
        }

        // Populate hidden required fields with data so they can pass server-side validation
        const populateHiddenRequiredAddressFields = () => {
            const addressAreas = document.querySelectorAll("[data-address-type]");
            addressAreas.forEach((addressArea) => {
                var addressAreaHidden = addressArea.classList.contains("hide");
                var requiredFields = addressArea.querySelectorAll("input[required]");
                requiredFields.forEach((requiredField) => {
                    if (addressAreaHidden && requiredField.value === "") {
                        requiredField.value = "empty";
                    } else if (!addressAreaHidden && requiredField.value === "empty") {
                        requiredField.value = "";
                    }
                });
            });
        };
        populateHiddenRequiredAddressFields();
        // Same as above but for Emergency Address fields
        const populateHiddenRequiredEmergencyFields = () => {
            const addressArea = document.querySelector('[data-section="emergency-address"]');
            var addressAreaHidden = addressArea.classList.contains("hide");
            var requiredFields = addressArea.querySelectorAll("input[required]");
            requiredFields.forEach((requiredField) => {
                if (addressAreaHidden && requiredField.value === "") {
                    requiredField.value = "empty";
                } else if (!addressAreaHidden && requiredField.value === "empty") {
                    requiredField.value = "";
                }
            });
        };
        populateHiddenRequiredEmergencyFields();

        // Start Again - Clear Address Data Button
        const startAgainButton = document.querySelector(".start-again");
        if (startAgainButton) {
            const mainAddressContainer = document.querySelector(".main-address-form-2");
            var qasList = document.querySelector(".address-list-qas");
            var bfoList = document.querySelector(".address-list-bfo");
            // Add a click event listener to the Clear Fields button
            startAgainButton.addEventListener("click", function () {
                if (qasList && bfoList) {
                    qasList.innerHTML = "";
                    bfoList.innerHTML = "";
                }

                const inputFields = mainAddressContainer.querySelectorAll("input:not(.hidden), select:not(.hidden)");
                inputFields.forEach(function (field) {
                    let parentElement = field.parentElement;
                    while (parentElement && !parentElement.classList.contains("hide")) {
                        parentElement = parentElement.parentElement;
                    }
                    if (!parentElement && !field.hasAttribute("data-address-style") && !field.hasAttribute("data-address-type-main")) {
                        field.value = "";
                    }
                });
            });
        }

        // Start Again - Clear Emergency Address Data Button
        const ecStartAgainButton = document.querySelector(".ec-start-again");
        if (ecStartAgainButton) {
            const ecAddressContainer = document.querySelector('[data-section="emergency-address"]');
            var ecQasList = document.querySelector(".ec-qas-address-list");
            var ecBfoList = document.querySelector(".ec-bfpo-address-list");
            // Add a click event listener to the Clear Fields button
            ecStartAgainButton.addEventListener("click", function () {
                if (qasList && bfoList) {
                    ecQasList.innerHTML = "";
                    ecBfoList.innerHTML = "";
                }
                // Find all the input fields and selects inside the main-address div
                const inputFields = ecAddressContainer.querySelectorAll('[data-ec="address1-input"], [data-ec="address2-input"], [data-ec="address3-input"], [data-ec="city-input"], [data-ec="county-input"], [data-ec="postcode-input"]');

                // Loop through each input field or select
                inputFields.forEach(function (field) {
                    // Check if the current field does not have the attributes data-address-demo or data-address-test
                    field.value = "";
                });
            });
        }

        const getChangeFieldData = (changeField) => {
            const changeFieldName = changeField.getAttribute("data-change");
            let extraSelector = "";
            if (changeFieldName === "addrchange") {
                // For addrchange, we only want to check if the fields relevant to the current address style have changed
                const addressStyle = document.querySelector(`[data-address-style]`).value;
                extraSelector = `[data-address-type-main], [data-address-style], [data-address-type="${addressStyle}"] `;
            }
            const dependentChangeFields = document.querySelectorAll(`${extraSelector}[data-${changeFieldName}]`);
            let changeFieldValues = "";
            dependentChangeFields.forEach((dependentChangeField) => {
                if (dependentChangeField.type === "radio" || dependentChangeField.type === "checkbox") {
                    changeFieldValues += `${dependentChangeField.checked}|`;
                } else {
                    changeFieldValues += `${dependentChangeField.value}|`;
                }
            });
            let fieldData = {};
            fieldData.name = changeFieldName;
            fieldData.values = changeFieldValues;
            return fieldData;
        };

        let changeFieldData = [];
        const setChangeFieldData = () => {
            const changeFields = document.querySelectorAll("[data-change]");
            changeFields.forEach((changeField) => {
                const fieldData = getChangeFieldData(changeField);
                changeFieldData[fieldData.name] = fieldData.values;
            });
        };
        setChangeFieldData();

        const setChangedFieldFlags = () => {
            const changeFields = document.querySelectorAll("[data-change]");
            changeFields.forEach((changeField) => {
                const fieldData = getChangeFieldData(changeField);
                const field = document.querySelector(`[data-change="${fieldData.name}"]`);
                if (changeFieldData[fieldData.name] === fieldData.values) {
                    field.value = "N";
                } else {
                    field.value = "Y";
                }
            });
        };

        // Custom validation
        const contactFormValidation = (field) => {
            let error = "";
            const fieldName = field.getAttribute("data-name");
            const fieldValue = field.value;
            switch (fieldName) {
                case "emergencyflag":
                    let phoneArray = document.querySelector("[data-phone-array]").value;
                    phoneArray = JSON.parse(phoneArray);
                    phoneArray = phoneArray.filter((number) => number.action !== "D");
                    const nextOfKinFlag = document.querySelector('[data-name="nextofkinflag"]').checked;
                    if ((field.checked || nextOfKinFlag) && phoneArray.length === 0) {
                        error = "An Emergency or Next of Kin Contact requires at least one Contact Phone Number";
                    }
                    break;
                case "verifyPhoneMessage":
                    let phoneArray2 = document.querySelector("[data-phone-array]").value;
                    phoneArray2 = JSON.parse(phoneArray2);
                    phoneArray2 = phoneArray2.filter((number) => number.action !== "D");
                    const emergencyflag = document.querySelector('[data-name="emergencyflag"]').checked;
                    const nextOfKinFlag2 = document.querySelector('[data-name="nextofkinflag"]').checked;
                    if ((emergencyflag || nextOfKinFlag2) && phoneArray2.length === 0) {
                        error = "An Emergency or Next of Kin Contact requires at least one Contact Phone Number";
                    }
                    break;
                case "relndatestart":
                    const relationshipStartDate = new Date(fieldValue);
                    const userDateOfBirth = new Date(field.getAttribute("data-persdateofbirth"));
                    if (relationshipStartDate < userDateOfBirth) {
                        error = "Relationship Start Date must be on, or later than, the user's Date of Birth";
                    } else {
                        const contactDateOfBirthField = document.querySelector('[data-name="condateofbirth"]');
                        if (contactDateOfBirthField) {
                            const contactDateOfBirth = new Date(contactDateOfBirthField.value);
                            if (relationshipStartDate && contactDateOfBirth) {
                                if (relationshipStartDate < contactDateOfBirth) {
                                    error = "Relationship Start Date must be on, or later than, the contact's Date of Birth";
                                }
                            }
                        }
                    }
                    break;
                case "xx-addrpostalcode":
                    if (!fieldValue.startsWith("BFPO")) {
                        error = 'BFPO Number must be prefixed with "BFPO" (uppercase)';
                    }
                    break;
            }
            return error;
        };

        // Form validation
        submitButton.addEventListener("click", (event) => {
            event.preventDefault();
            setChangedFieldFlags();
            if (simpleFormValidation(form, true, contactFormValidation)) {
                form.submit();
            }
        });
        // Validate fields with errors on change
        const formFields = form.querySelectorAll("input, select");
        formFields.forEach((formField) => {
            formField.addEventListener("change", () => {
                simpleFormValidation(form, false, contactFormValidation);
            });
        });

        // A Contact cannot be an Emergency Contact and an Additional Nominee at the same time
        const contactTypeCheckboxes = document.querySelectorAll('input[data-input="emergencyflag"], input[data-input="additionalnomineeflag"]');
        contactTypeCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("click", () => {
                const emergencyContactInput = document.querySelector('input[data-input="emergencyflag"]');
                const additionalNomineeInput = document.querySelector('input[data-input="additionalnomineeflag"]');
                emergencyContactInput.disabled = true;
                additionalNomineeInput.disabled = true;
                if (!emergencyContactInput.checked && additionalNomineeInput.hasAttribute("data-allowed")) {
                    additionalNomineeInput.disabled = false;
                }
                if (!additionalNomineeInput.checked && emergencyContactInput.hasAttribute("data-allowed")) {
                    emergencyContactInput.disabled = false;
                }
            });
        });
    }
})();
